// 生成周一到周日零点的时时间序列
export function generateDateRange(date: Date) {
    const dayTime = 1000 * 3600 * 24 // 一天
    const curDate = new Date(date.setHours(0, 0, 0, 0)) // 当天零点
    let curDay = curDate.getDay() // 当天星期
    if (curDay === 0) { curDay = 7 }
    const dateRange = []
    const curTime = curDate.getTime()
    for (let i = 1; i <= 7; i++) {
        dateRange.push(new Date(curTime + ((i - curDay) * dayTime)))
    }
    return dateRange
}
